import { render, staticRenderFns } from "./EstimativaRitmoFiltracaoGlomerular.vue?vue&type=template&id=4d0551c6"
import script from "./EstimativaRitmoFiltracaoGlomerular.vue?vue&type=script&lang=js"
export * from "./EstimativaRitmoFiltracaoGlomerular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports